/**
 * Creates timeout with reference ID that is used to
 * automatically clear the timeout ater completing
 *
 * @param {function} timeoutFunction - function to call after timeout
 * @param {function} time - duration of timeout in milliseconds
 * @returns {null}
 */
export function useTimeout(timeoutFunction, time) {
  if (!time || !timeoutFunction || typeof timeoutFunction != 'function') {
    return;
  }
  let timeoutId = null;
  timeoutId = setTimeout(() => {
    timeoutFunction();
    // clear timer ref on completion of timeoutFunction
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }, time);
  return;
}
